import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createVehicleAssignment, deleteVehicleAssignment } from "../services";
import type { CreateVehicleAssignmentRequest } from "../types";
import { VEHICLE_ASSIGNMENTS_QUERY_KEY } from "./get-vehicle-assignments.query";

export const useCreateVehicleAssignment = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (payload: CreateVehicleAssignmentRequest) =>
			createVehicleAssignment(payload),
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({
				queryKey: [VEHICLE_ASSIGNMENTS_QUERY_KEY, String(variables.vehicleId)],
			});
		},
	});
};

export const useDeleteVehicleAssignment = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			vehicleAssignmentId,
		}: {
			vehicleAssignmentId: string;
			vehicleId: string;
		}) => deleteVehicleAssignment(vehicleAssignmentId),
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({
				queryKey: [VEHICLE_ASSIGNMENTS_QUERY_KEY, variables.vehicleId],
			});
		},
	});
};
